<template>
    <div class="levels" v-if="$can('level_view')">
      <v-snackbar v-model="snackbar" :timeout="4000" bottom right :color="color">
        <span>{{ message }}</span>
      </v-snackbar>
    <div class="pa-5">
        <v-layout column>
          <div v-if="view == 'default'">
            <v-card elevation="0" class="mt-5">
              
              <v-flex xs12 class="mt-10 mb-2">
                <div class="mx-5">
                  <v-layout row wrap>
                    <v-flex xs12 md6> 
                        <div v-if="length != 0" align="left" class="mt-1">
                            <b class="display-1 primary--text">Total: </b
                            >{{ levelPagination.total | formatNumber }}
                        </div>
                    </v-flex>
                    <v-flex xs12 md4>
                      <div class="pa-1">
                        <v-text-field
                          class="text_field background"
                          outlined
                          dense
                          rounded
                          label="Search"
                          append-icon="mdi-undo-variant"
                          @click:append="resetSearch()"
                          v-on:keyup.enter="search"
                          v-model="searchTerm"
                          @input="enableSearch()"
                        ></v-text-field>
                      </div>
                    </v-flex>
                    <v-flex xs12 md2>
                      <div class="pa-1" align="right">
                        <v-btn
                          class="button mx-1"
                          icon
                          @click="search"
                          :loading="searchLoader"
                          :disabled="searchButtonDisabled"
                        >
                          <v-icon class="secondary--text">mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn
                            icon
                          class="button mx-1"
                          @click="changeView('create')"
                          v-if="$can('level_create')"
                        >
                        
                          <v-icon class="primary--text">mdi-plus-circle-outline</v-icon>
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
              <v-divider class="mt-9 mx-5"></v-divider>
              <v-progress-linear
                v-if="levelLoader"
                height="1"
                indeterminate
                color="primary"
              >
              </v-progress-linear>
              <v-flex xs12 class="mt-5">
                <div v-if="levels.length == 0">
                  <v-card elevation="0">
                    <v-layout row wrap>
                      <v-flex xs12 md1>
                        <v-container fill-height fluid>
                          <v-row align="center" justify="center">
                            <v-col class="text-center">
                              <v-icon large class="primary--text">
                                mdi-alert-circle-outline
                              </v-icon>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-flex>
                      <v-flex xs12 md11>
                        <v-container fill-height fluid>
                          <v-row align="center" justify="center">
                            <v-col class="text-center">
                              No Level Found
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </div>
                <div v-else>
                  <div class="hidden-sm-and-down">
                    <v-card elevation="0" class="pa-2">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead class="header">
                            <tr class="accent">
                              <th class="text-left text--text">Name</th>
                              <th class="text-left text--text">Status</th>
                              <th class="text-left text--text">Date Created</th>
                              <th class="text-right text--text">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in levels" :key="item.id">
                              
                              <td>{{ item.name }}</td>                             
                              <td>
                                <div v-if="item.status == 1">Active</div>
                                <div v-else>Inactive</div>
                              </td>
                              <td>
                                {{
                                  item.created_at | moment("DD/MM/YYYY - hh:mm a")
                                }}
                              </td>
                              <td>
                                <div align="right">
                                  <v-btn
                                    icon
                                    v-if="$can('level_view')"
                                    @click="showLevel(item)"
                                    class="button mr-1 universal--text"
                                  >
                                    <v-icon small> mdi-eye </v-icon>
                                  </v-btn>
                                  <v-btn
                                    v-if="$can('level_edit')"
                                    icon
                                    class="button mr-1 success--text"
                                    @click="editLevel(item)"
                                  >
                                    <v-icon small> mdi-pencil </v-icon>
                                  </v-btn>
                                  <v-btn
                                    v-if="$can('level_archive')"
                                    icon
                                    class="button mr-1 error--text"
                                    @click="deleteLevel(item)"
                                    :loading="
                                      loading && levelIndex == item.id
                                    "
                                  >
                                    <v-icon small> mdi-delete </v-icon>
                                  </v-btn>
                                  <v-tooltip
                                    top
                                    v-if="
                                      $can('level_activate') &&
                                      item.status == 0
                                    "
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon
                                        class="button mr-1 red--text"
                                        @click="activateLevel(item)"
                                        :loading="
                                          activateLoading &&
                                          levelIndex == item.id
                                        "
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <v-icon small>
                                          mdi-toggle-switch-off-outline
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Activate Level</span>
                                  </v-tooltip>
                                  <v-tooltip
                                    top
                                    v-if="
                                      $can('level_deactivate') &&
                                      item.status == 1
                                    "
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon
                                        class="button mr-1 green--text"
                                        @click="deactivateLevel(item)"
                                        :loading="
                                          deactivateLoading &&
                                          levelIndex == item.id
                                        "
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <v-icon small> mdi-toggle-switch </v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Deactivate Level</span>
                                  </v-tooltip>
                                  <v-tooltip top v-if="$can('log_view')">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon
                                        class="button mr-1 purple--text"
                                        @click="viewLog(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <v-icon small> mdi-script-text </v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Log</span>
                                  </v-tooltip>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card>
                  </div>
                  <div class="hidden-md-and-up">
                    <div>
                      <v-layout column>
                        <template v-for="(level, index) in levels">
                          <div :key="index">
                            <v-flex xs12 class="mb-2">
                              <v-card elevation="0" style="border-radius: 25px;" outlined>
                                <div class="pa-7">
                                  <v-layout column>
                                    <v-flex xs12>
                                      <v-layout row wrap>
                                        <v-flex xs11>
                                          <div class="title primary--text">
                                            <b>{{ level.name }}</b>
                                          </div>
                                        </v-flex>
                                        <v-flex xs1>
                                          <v-btn
                                            depressed
                                            class="red--text"
                                            :loading="
                                              loading &&
                                              levelIndex == level.id
                                            "
                                            icon
                                            @click="
                                              deleteLevel(level)
                                            "
                                            v-if="$can('level_archive')"
                                          >
                                            <v-icon> mdi-delete </v-icon>
                                          </v-btn>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                    <v-divider class="mt-2"></v-divider>
                                    <v-flex xs12 class="mt-1">
                                      <v-layout column>
                                       
                                        <v-flex xs12 class="mt-5">
                                          <v-layout row wrap>
                                            <v-flex xs4>
                                              <b>Status</b>
                                            </v-flex>
                                            <v-flex xs8>
                                              <div v-if="level.status == 1">Active</div>
                                              <div v-else>Inactive</div>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs12 class="mt-5">
                                          <v-layout row wrap>
                                            <v-flex xs4>
                                              <b>Date Created</b>
                                            </v-flex>
                                            <v-flex xs8>
                                              {{
                                                level.created_at
                                                  | moment("DD/MM/YYYY - hh:mm a")
                                              }}
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs12 class="mt-5">
                                          <v-layout row wrap>
                                            <v-flex xs12 v-if="$can('level_view')">
                                              <div>
                                                <v-btn
                                                  rounded
                                                  depressed
                                                  class="primary text-none white--text mt-3"
                                                  block
                                                  @click="
                                                    showLevel(level)
                                                  "
                                                  
                                                  >View
                                                  <v-icon right> mdi-eye </v-icon>
                                                </v-btn>
                                              </div>
                                            </v-flex>
                                            <v-flex xs12 v-if="$can('level_edit')">
                                              <div>
                                                <v-btn
                                                  rounded
                                                  depressed
                                                  class="blue text-none white--text mt-1"
                                                  block
                                                  @click="
                                                    editLevel(level)
                                                  "
                                                  
                                                  >Edit
                                                  <v-icon right>
                                                    mdi-border-color
                                                  </v-icon>
                                                </v-btn>
                                              </div>
                                            </v-flex>
                                            <v-flex xs12 v-if="$can('level_activate') &&
                                                    level.status == 0">
                                              <div>
                                                <v-btn
                                                  depressed
                                                  class="green text-none white--text mt-1"
                                                  block
                                                  :loading="
                                                    activateLoading &&
                                                    levelIndex == level.id
                                                  "
                                                  @click="
                                                    activateLevel(level)
                                                  "
                                                  rounded
                                                  >Activate Level
                                                  <v-icon right>
                                                    mdi-toggle-switch-off-outline
                                                  </v-icon>
                                                </v-btn>
                                              </div>
                                            </v-flex>
                                            <v-flex xs12 v-if="$can('level_deactivate') &&
                                                    level.status == 1">
                                              <div>
                                                <v-btn
                                                  depressed
                                                  class="red text-none white--text mt-1"
                                                  block
                                                  :loading="
                                                    deactivateLoading &&
                                                    levelIndex == level.id
                                                  "
                                                  @click="
                                                    deactivateLevel(level)
                                                  "
                                                  rounded
                                                  >Deactivate Level
                                                  <v-icon right>
                                                    mdi-toggle-switch
                                                  </v-icon>
                                                </v-btn>
                                              </div>
                                            </v-flex>
                                            <v-flex xs12 v-if="$can('log_view')" >
                                              <div class="mt-1">
                                                <v-btn
                                                rounded
                                                  block
                                                  depressed
                                                  class="purple text-none white--text"
                                                  @click="viewLog(level)"
                                                  v-bind="attrs"
                                                  v-on="on"
                                                > Log
                                                  <v-icon small> mdi-script-text </v-icon>
                                                </v-btn>
                                              </div>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </v-card>
                            </v-flex>
                          </div>
                        </template>
                      </v-layout>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-card>
            <v-layout column class="mt-5">
              <v-flex xs12>
                <div align="left">
                  <v-pagination
                    v-if="length != 0"
                    :length="length"
                    total-visible="10"
                    v-model="levelPagination.current_page"
                    @input="changePage()"
                    circle
                  >
                  </v-pagination>
                </div>
              </v-flex>
              
            </v-layout>
          </div>
          <div v-if="view == 'create'">
            <v-flex class="mt-5">
              <v-card outlined>
                <v-card-title class="accent text--text">
                  <v-img
                    v-if="newLevel.id != null"
                    src="img/badge.png"
                    max-width="40"
                  ></v-img>
                  <v-spacer></v-spacer>
                  <div v-if="newLevel.id == null">Add Level</div>
                  <div v-else>Edit Level</div>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="changeView('default')">
                    <v-icon class="text--text"> mdi-close </v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-form v-model="valid" ref="form" lazy-validation>
                    <v-layout row wrap class="mt-5">
                      <v-flex xs12 md4>
                        <div class="pa-3">
                          <div>Name<span class="error--text">*</span></div>
                          <v-text-field
                            class="text_field background my-2"
                            outlined
                            dense
                            v-model="newLevel.name"
                            :rules="inputRules"
                          ></v-text-field>
                        </div>
                      </v-flex>
                  
                    </v-layout>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    class="primary text-none mt-3"
                    @click="save"
                    :disabled="!valid"
                    :loading="loading"
                  >
                    Save
                    <v-icon right> mdi-content-save </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </div>
          <div v-if="view == 'show'">
            <v-card outlined class="mt-5">
              <v-progress-linear
                v-if="subLevelLoader"
                height="1"
                indeterminate
                color="primary"
              >
              </v-progress-linear>
              <v-card-title class="accent text--text">
                <v-spacer></v-spacer>
                <div>View Level</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="changeView('default')">
                  <v-icon> mdi-close </v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <div class="pa-1">
                  <v-tabs show-arrows v-model="levelTab">
                    <v-tabs-slider color="primary"></v-tabs-slider>
  
                    <v-tab @click="activeTab = 'details'">
                      <div class="text-none primary--text">Details</div>
                    </v-tab>
                    <v-tab
                      @click="activeTab = 'subLevels'"
                    >
                      <div class="text-none primary--text">
                        Sub Levels ({{
                          subLevelPagination.total
                        }})
                      </div>
                    </v-tab>
                  </v-tabs>
                  <div v-if="activeTab == 'details'">
                    <v-card-text>
                      <div class="pa-3">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-layout column class="mt-3">
                              <v-flex xs12>
                                <v-layout row wrap>
                                  <v-flex xs12 md6>
                                    <v-layout column>
                                      <v-flex xs12 class="mt-6">
                                        <v-layout row wrap>
                                          <v-flex xs12 md4>
                                            <b>Level Name: </b>
                                          </v-flex>
                                          <v-flex xs12 md8>
                                            <div>
                                              {{ assignedLevel.name }}
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                      <v-flex xs12 class="mt-6">
                                        <v-layout row wrap>
                                          <v-flex xs12 md4>
                                            <b>Status: </b>
                                          </v-flex>
                                          <v-flex xs12 md8>
                                            <div
                                              v-if="
                                                assignedLevel.status == 1
                                              "
                                            >
                                              Active
                                            </div>
                                            <div v-else>Inactive</div>
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 md6>
                                    <v-layout column>
                                      
                                      <v-flex xs12 class="mt-6">
                                        <v-layout row wrap>
                                          <v-flex xs12 md4>
                                            <b>Date Created: </b>
                                          </v-flex>
                                          <v-flex xs12 md8>
                                            <div>
                                              {{
                                                assignedLevel.created_at
                                                  | moment("DD/MM/YYYY - hh:mm a")
                                              }}
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-card-text>
                  </div>
  
                  <div v-if="activeTab == 'subLevels'">
                    <div v-if="subLevelView == 'default'">
                      <v-card elevation="0" class="mt-5">
                        <v-flex xs12 class="mt-10 mb-2">
                          <div class="mx-5">
                            <v-layout row wrap>
                              <v-flex xs12 md6>
                                <div
                                    v-if="subLevelLength != 0"
                                    align="left"
                                    class="mt-1"
                                >
                                    <b class="display-1 primary--text">Total: </b
                                    >{{
                                    subLevelPagination.total
                                        | formatNumber
                                    }}
                                </div>
                              </v-flex>
                              <v-flex xs12 md4>
                                <div class="pa-1">
                                  <v-text-field
                                    class="text_field background"
                                    outlined
                                    dense
                                    rounded
                                    label="Search"
                                    append-icon="mdi-undo-variant"
                                    @click:append="
                                      resetSubLevelSearch()
                                    "
                                    v-on:keyup.enter="
                                      subLevelSearch
                                    "
                                    v-model="subLevelSearchTerm"
                                    @input="
                                      enableSubLevelSearch()
                                    "
                                  ></v-text-field>
                                </div>
                              </v-flex>
                              <v-flex xs12 md2>
                                <div class="pa-1" align="right">
                                  <v-btn
                                    class="button mx-1"
                                    icon
                                    @click="subLevelSearch"
                                    :loading="
                                      subLevelSearchLoader
                                    "
                                    :disabled="
                                      subLevelSearchButtonDisabled
                                    "
                                  >
                                    
                                    <v-icon class="secondary--text">mdi-magnify</v-icon>
                                  </v-btn>
                                  <v-btn
                                    icon
                                    class="button mx-1"
                                    @click="
                                      changeSubLevelView(
                                        'create'
                                      )
                                    "
                                    v-if="
                                      $can('sub_level_create')
                                    "
                                  >
                                    <v-icon class="primary--text">mdi-plus-circle-outline</v-icon>
                                  </v-btn>
                                </div>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-flex>
                        <v-divider class="mt-9 mx-5"></v-divider>
                        <v-flex xs12 class="mt-5">
                          <div v-if="subLevels.length == 0">
                            <v-card elevation="0">
                              <v-layout row wrap>
                                <v-flex xs12 md1>
                                  <v-container fill-height fluid>
                                    <v-row align="center" justify="center">
                                      <v-col class="text-center">
                                        <v-icon large class="text--text">
                                          mdi-alert-circle-outline
                                        </v-icon>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-flex>
                                <v-flex xs12 md11>
                                  <v-container fill-height fluid>
                                    <v-row align="center" justify="center">
                                      <v-col class="text-center">
                                        No Sub Level Found
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </div>
                          <div v-else>
                            <div class="hidden-sm-and-down">
                              <v-card elevation="0" class="pa-2">
                                <v-simple-table>
                                  <template v-slot:default>
                                    <thead class="header">
                                      <tr class="accent">
                                        <th class="text-left text--text">Name</th>
                                        <th class="text-left text--text">Date Created</th>
                                        <th class="text-left text--text">Status</th>
                                        <th class="text-right text--text">Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="item in subLevels"
                                        :key="item.id"
                                      >
                                        <td>
                                          {{ item.name }}
                                        </td>
                                        <td>
                                            {{
                                                item.created_at | moment("DD/MM/YYYY - hh:mm a")
                                            }}
                                        </td>
                                        <td>
                                          <div v-if="item.status == 1">
                                            Active
                                          </div>
                                          <div v-else>Inactive</div>
                                        </td>
                                        <td>
                                          <div align="right">
                                            <v-btn v-if="$can('sub_level_view')"
                                              icon
                                              @click="
                                                showSubLevel(
                                                  item
                                                )
                                              "
                                              class="button mr-1 universal--text"
                                            >
                                              <v-icon small> mdi-eye </v-icon>
                                            </v-btn>
                                            <v-btn
                                                v-if="$can('sub_level_edit')"
                                                icon
                                                class="button mr-1 success--text"
                                                @click="editSubLevel(item)"
                                            >
                                                <v-icon small> mdi-pencil </v-icon>
                                            </v-btn>
                                            <v-btn
                                              v-if="
                                                $can(
                                                  'sub_level_archive'
                                                )
                                              "
                                              icon
                                              class="button mr-1 error--text"
                                              @click="
                                                deleteSubLevel(
                                                  item
                                                )
                                              "
                                              :loading="
                                                loading &&
                                                subLevelndex ==
                                                  item.id
                                              "
                                            >
                                              <v-icon small> mdi-delete </v-icon>
                                            </v-btn>
                                            <v-tooltip
                                              top
                                              v-if="
                                                $can(
                                                  'sub_level_activate'
                                                ) && item.status == 0
                                              "
                                            >
                                              <template
                                                v-slot:activator="{ on, attrs }"
                                              >
                                                <v-btn
                                                  icon
                                                  class="button mr-1 red--text"
                                                  @click="
                                                    activateSubLevel(
                                                      item
                                                    )
                                                  "
                                                  :loading="
                                                    activateLoading &&
                                                    subLevelndex ==
                                                      item.id
                                                  "
                                                  v-bind="attrs"
                                                  v-on="on"
                                                >
                                                  <v-icon small>
                                                    mdi-toggle-switch-off-outline
                                                  </v-icon>
                                                </v-btn>
                                              </template>
                                              <span>Activate Part</span>
                                            </v-tooltip>
                                            <v-tooltip
                                              top
                                              v-if="
                                                $can(
                                                  'sub_level_deactivate'
                                                ) && item.status == 1
                                              "
                                            >
                                              <template
                                                v-slot:activator="{ on, attrs }"
                                              >
                                                <v-btn
                                                  icon
                                                  class="button mr-1 green--text"
                                                  @click="
                                                    deactivateSubLevel(
                                                      item
                                                    )
                                                  "
                                                  :loading="
                                                    deactivateLoading &&
                                                    subLevelndex ==
                                                      item.id
                                                  "
                                                  v-bind="attrs"
                                                  v-on="on"
                                                >
                                                  <v-icon small>
                                                    mdi-toggle-switch
                                                  </v-icon>
                                                </v-btn>
                                              </template>
                                              <span>Deactivate Sub Level</span>
                                            </v-tooltip>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-card>
                            </div>
                            <div class="hidden-md-and-up">
                              <div>
                                <v-layout column>
                                  <template
                                    v-for="(
                                      part, index
                                    ) in subLevels"
                                  >
                                    <div :key="index">
                                      <v-flex xs12 class="mb-2">
                                        <v-card elevation="0" style="border-radius: 25px;" outlined>
                                          <div class="pa-7 mt-2">
                                            <v-layout column>
                                              <v-flex xs12>
                                                <v-layout row wrap>
                                                  <v-flex xs11>
                                                    <div
                                                      class="title primary--text"
                                                    >
                                                      <b
                                                        >{{
                                                          part.name
                                                        }}</b
                                                      >
                                                    </div>
                                                  </v-flex>
                                                  <v-flex xs1>
                                                    <v-btn
                                                      depressed
                                                      class="red--text"
                                                      :loading="
                                                        loading &&
                                                        subLevelndex ==
                                                          part.id
                                                      "
                                                      icon
                                                      @click="
                                                        deleteSubLevel(
                                                          part
                                                        )
                                                      "
                                                      v-if="
                                                        $can(
                                                          'sub_level_archive'
                                                        )
                                                      "
                                                    >
                                                      <v-icon>
                                                        mdi-delete
                                                      </v-icon>
                                                    </v-btn>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>
                                              <v-divider class="mt-2"></v-divider>
                                              <v-flex xs12 class="mt-1">
                                                <v-layout column>
                                                  <v-flex xs12 class="mt-5">
                                                    <v-layout row wrap>
                                                      <v-flex xs4>
                                                        <b>Status</b>
                                                      </v-flex>
                                                      <v-flex xs8>
                                                        <div
                                                          v-if="
                                                            part.status ==
                                                            1
                                                          "
                                                        >
                                                          Active
                                                        </div>
                                                        <div v-else>Inactive</div>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-flex>
                                                  <v-flex xs12 class="mt-5">
                                                    <v-layout row wrap>
                                                      <v-flex xs4>
                                                        <b>Date Created</b>
                                                      </v-flex>
                                                      <v-flex xs8>
                                                        {{
                                                          part.created_at | moment("DD/MM/YYYY - hh:mm a")
                                                        }}
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-flex>
  
                                                  <v-flex xs12 class="mt-5">
                                                    <v-layout row wrap>
                                                      
                                                      <v-flex xs12  v-if="
                                                              $can(
                                                                'sub_level_activate'
                                                              ) && part.status == 0
                                                            ">
                                                        <div>
                                                          <v-btn
                                                            rounded
                                                            depressed
                                                            class="green darken-1 text-none white--text mt-1"
                                                            block
                                                            :loading="
                                                              activateLoading &&
                                                              subLevelndex ==
                                                                part.id
                                                            "
                                                            @click="
                                                              activateSubLevel(
                                                                part
                                                              )
                                                            "
                                                           
                                                            >Activate Part
                                                            <v-icon right>
                                                              mdi-toggle-switch
                                                            </v-icon>
                                                          </v-btn>
                                                        </div>
                                                      </v-flex>
                                                      <v-flex xs12 v-if="
                                                              $can(
                                                                'sub_level_deactivate'
                                                              ) && part.status == 1
                                                            ">
                                                        <div>
                                                          <v-btn
                                                            rounded
                                                            depressed
                                                            class="red darken-1 text-none white--text mt-1"
                                                            block
                                                            :loading="
                                                              deactivateLoading &&
                                                              subLevelndex ==
                                                                part.id
                                                            "
                                                            @click="
                                                              deactivateSubLevel(
                                                                part
                                                              )
                                                            "
                                                            
                                                            >Deactivate Sub Level
                                                            <v-icon right>
                                                              mdi-toggle-switch-off-outline
                                                            </v-icon>
                                                          </v-btn>
                                                        </div>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>
                                            </v-layout>
                                          </div>
                                        </v-card>
                                      </v-flex>
                                    </div>
                                  </template>
                                </v-layout>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-card>
                      <v-layout column class="mt-5">
                        <v-flex xs12>
                          <div align="left">
                            <v-pagination
                              v-if="length != 0"
                              :length="subLevelLength"
                              total-visible="10"
                              v-model="
                                subLevelPagination.current_page
                              "
                              @input="changeSubLevelPage()"
                              circle
                            >
                            </v-pagination>
                          </div>
                        </v-flex>
                      </v-layout>
                    </div>
                    <div v-if="subLevelView == 'create'">
                      <v-flex class="mt-5">
                        <v-card-title class="accent text--text">
                          <v-spacer></v-spacer>
                          <div v-if="newSubLevel.id == null">
                            Add Sub-Level
                          </div>
                          <div v-else>Edit Sub-Level</div>
                          <v-spacer></v-spacer>
                          <v-btn
                            icon
                            @click="
                              changeSubLevelView('default')
                            "
                          >
                            <v-icon class="text--text"> mdi-close </v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-text>
                          <v-form
                            v-model="valid"
                            ref="subLevelForm"
                            lazy-validation
                          >
                            <v-layout row wrap class="mt-5">
                              <v-flex xs12 md4>
                                <div class="pa-3">
                                  <div>
                                    Sub-Level Name<span class="error--text">*</span>
                                  </div>
                                  <v-text-field
                                        class="text_field background my-2"
                                        outlined
                                        dense
                                        v-model="newSubLevel.name"
                                        :rules="inputRules"
                                    ></v-text-field>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-form>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            depressed
                            class="primary text-none mt-3"
                            @click="saveSubLevel"
                            :disabled="!valid"
                            :loading="loading"
                          >
                            Save
                            <v-icon right> mdi-content-save </v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-flex>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </v-layout>
      </div>
      <logData v-if="logDataModel" v-model="logDataModel" />
    </div>
  </template>
  <style>
  .ck-editor__editable {
    min-height: 200px;
  }
  </style>
  <script>
  import Vue from "vue";
  import apiCall from "@/utils/api";
  import { mapGetters, mapState, mapActions } from "vuex";
  import logData from "@/views/accessControl/logData";
  import CKEditor from "@ckeditor/ckeditor5-vue2";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
  
  Vue.use(CKEditor);
  
  export default {
    components: {
      logData,
    },
    data() {
      return {
        path: process.env.VUE_APP_API_URL,
  
        editor: ClassicEditor,
        editorConfig: {},
  
        importDialog: false,
        activeTab: "details",
        
        view: "default",
        subLevelView: "default",
  
        contactView: "default",
        loading: false,
        subLevelLoader: false,
  
        activateLoading: false,
        deactivateLoading: false,
  
        valid: true,
        message: "",
        color: "",
        delete: false,
        activate: false,
        confirm: false,
        tab: null,
        
        levelTab: null,
        subLevelndex: null,
        levelIndex: null,
  
        snackbar: false,
        inputRules: [(v) => !!v || "Input is required"],
  
        emailRules: [
          (v) =>
            !v ||
            /^[a-zA-Z0-9\.!#$%&'*+/=?^_~-]+@([a-zA-Z0-9]+\.)+[a-zA-Z]{2,3}$/.test(
              v
            ) ||
            "E-mail must be valid",
          (v) => !v || (v && v.length <= 50) || "Maximum 50 characters",
        ],
        websiteRules: [
          (v) =>
            !v ||
            /^[a-zA-Z0-9\.!#:$%&'*+/=?^_~-]+[a-zA-Z]{2,3}$/.test(v) ||
            "URL must be valid",
          (v) => !v || (v && v.length <= 50) || "Maximum 50 characters",
        ],
  
        items: [],
        searchParts: null,
  
        searchTerm: null,
        subLevelSearchTerm: null,
  
        searchLoader: false,
        searchButtonDisabled: false,
        subLevelSearchButtonDisabled: false,
  
  
        filteredLevels: false,
        filteredLevelParts: false,
  
        years: [],
        newLevel: {
          id: null,
          name: null,
        },  
        newSubLevel: {
          id: null,
          level_id: null,
          name: null,
        },
  
        assignedLevel: null,
        formData: null,
  
        coverImageDialog: false,
        imageDialog: false,
        imageLoading: false,
        fileRules: [(v) => !!v || this.$t("kindlySelectAFileMsg")],
        imageFile: null,
        imageValid: true,
  
        searchTerm: null,
        searchLoader: false,
        subLevelSearchLoader: false,
  
        searchButtonDisabled: false,
  
        filteredLevels: [],
        subLevels: [],
  
        subLevelPagination: {
          search: " ",
          current_page: 1,
          per_page: 0,
          total: 0,
          visible: 10,
        },

        
        logData: {
          message: null,
          model: null,
        },
      };
    },
    watch: {
      searchParts(val) {
        val && val !== this.newSubLevel.user_id && this.findPart(val);
      },
    },
    created() {
      if (this.$can("level_view")) {
        this.startLevelLoader();
        this.fetchLevels(this.levelPagination.current_page);
        // this.getFormData();
        // this.populateYears();
      }
    },
    methods: {
      ...mapActions([
        "fetchLevels",
        "startLevelLoader",
        "stopLevelLoader",
        "filterLevels",
  
        "filterLogData",
        "openLogDataModel",
      ]),
      populateYears() {
        var max = new Date().getFullYear();
        var min = max - 100;
        var years = [];
  
        for (var i = max; i >= min; i--) {
          years.push(i);
        }
        this.years = years;
      },
      findPart(v) {
        this.loading = true;
        
        setTimeout(() => {
          apiCall({
            url: "/api/user?type=search&search=" + this.searchParts,
            method: "GET",
          })
            .then((resp) => {
              this.items = resp.data;
            })
            .catch((error) => {
              this.loading = false;
            });
  
          this.loading = false;
        }, 3000);
      },
  
      showSubLevel(user) {
        this.$router.push("/user/" + user.code);
      },
     
      enableSearch() {
        this.searchButtonDisabled = false;
      },
      
  
      enableSubLevelSearch() {
        this.subLevelSearchButtonDisabled = false;
      },
      
     
      resetSearch() {
        this.searchTerm = null;
        this.filteredLevels = true;
        this.startLevelLoader();
        this.fetchLevels(1);
      },    
  
      resetSubLevelSearch() {
        this.subLevelSearchTerm = null;
        this.filteredLevelParts = false;
        this.subLevelLoader = false;
        this.changeSubLevelPage();
      },

      changeSubLevelPage() {
        this.subLevelLoader = true;
        if (this.filteredLevelParts == true) {
          this.subLevelSearchButtonDisabled = false;
          apiCall({
            url:
              "/api/sub-level?level_id=" +
              this.assignedLevel.id +
              "&page=" +
              this.subLevelPagination.current_page +
              "&type=search&search=" +
              this.subLevelSearchTerm,
            method: "GET",
          })
            .then((resp) => {
              this.subLevelLoader = false;
  
              this.subLevels = resp.data;
              this.subLevelPagination.current_page =
                resp.current_page;
              this.subLevelPagination.total = resp.total;
              this.subLevelPagination.per_page = resp.per_page;
            })
            .catch((error) => {
              console.log(error);
              this.subLevelLoader = false;
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
            });
        } else {
          apiCall({
            url:
              "/api/sub-level?level_id=" +
              this.assignedLevel.id +
              "&page=" +
              this.subLevelPagination.current_page,
            method: "GET",
          })
            .then((resp) => {
              this.subLevelLoader = false;
  
              this.subLevels = resp.data;
              this.subLevelPagination.current_page =
                resp.current_page;
              this.subLevelPagination.total = resp.total;
              this.subLevelPagination.per_page = resp.per_page;
            })
            .catch((error) => {
              console.log(error);
              this.subLevelLoader = false;
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
            });
        }
      },
      
      getText(item) {
        return (
          item.first_name + " " + item.middle_name + " " + item.last_name + " #" + item.code
        );
      },
      showLevel(level) {
        this.assignedLevel = level;

        this.changeSubLevelPage();
        this.changeView("show");
      },
  
      editLevel(level) {
        this.newLevel.id = level.id;
        this.newLevel.name = level.name;
  
        console.log("this.newLevel", this.newLevel)
  
        this.changeView("create");
      },

      editSubLevel(subLevel) {
        this.newSubLevel.id = subLevel.id;
        this.newSubLevel.name = subLevel.name;
  
        console.log("this.newSubLevel", this.newSubLevel)
  
        this.changeSubLevelView("create");
      },
  
      save() {
        if (this.$refs.form.validate()) {
          if (this.newLevel.id != null) {
            confirm("Are you sure you want to update level?") &&
              (this.confirm = true);
            if (this.confirm) {
              this.loading = true;
              apiCall({
                url: "/api/level/" + this.newLevel.id,
                data: this.newLevel,
                method: "PUT",
              })
                .then((resp) => {
                  this.message = "Level Updated Successfully";
                  this.color = "orange";
                  this.loading = false;
                  this.snackbar = true;
                  this.confirm = false;
                  this.changeView("default");
                  this.fetchLevels(1);
                })
                .catch((error) => {
                  this.message = "An Error Occurred";
                  this.color = "error";
                  this.loading = false;
                  this.snackbar = true;
                });
            }
          } else {
            confirm("Are you sure you want to create level?") &&
              (this.confirm = true);
            if (this.confirm) {
              this.loading = true;
              apiCall({
                url: "/api/level",
                data: this.newLevel,
                method: "POST",
              })
                .then((resp) => {
                  this.message = "Level Added Successfully";
                  this.color = "success";
                  this.loading = false;
                  this.snackbar = true;
                  this.confirm = false;
                  this.changeView("default");
                  this.fetchLevels(1);
                })
                .catch((error) => {
                  this.message = "An Error Occurred";
                  this.color = "error";
                  this.loading = false;
                  this.snackbar = true;
                  this.changeView("default");
                  this.fetchLevels(1);
                });
            }
          }
        }
      },
  
      saveSubLevel() {
        if (this.$refs.subLevelForm.validate()) {
            if (this.newSubLevel.id != null) {
            confirm("Are you sure you want to update sub level?") &&
              (this.confirm = true);
            if (this.confirm) {
              this.loading = true;
              apiCall({
                url: "/api/sub-level/" + this.newSubLevel.id,
                data: this.newSubLevel,
                method: "PUT",
              })
                .then((resp) => {
                  this.message = "Sub-Level Updated Successfully";
                  this.color = "orange";
                  this.loading = false;
                  this.snackbar = true;
                  this.confirm = false;
                  this.changeSubLevelView("default");
                  this.changeSubLevelPage(1);
                })
                .catch((error) => {
                  this.message = "An Error Occurred";
                  this.color = "error";
                  this.loading = false;
                  this.snackbar = true;
                });
            }
          } else {


          confirm("Are you sure you want to add Sub-Level?") &&
            (this.confirm = true);
          if (this.confirm) {
            this.loading = true;
            this.newSubLevel.level_id = this.assignedLevel.id;
            apiCall({
              url: "/api/sub-level",
              data: this.newSubLevel,
              method: "POST",
            })
              .then((resp) => {
                this.message = "Level Part Added Successfully";
                this.color = "success";
                this.loading = false;
                this.snackbar = true;
                this.confirm = false;
                this.newSubLevel.user_id = null;
                this.changeSubLevelView("default");
                this.changeSubLevelPage();
              })
              .catch((error) => {
                this.message = "An Error Occurred";
                this.color = "error";
                this.loading = false;
                this.snackbar = true;
              });
          }
        }
        }
      },
  
      search() {
        if (this.searchTerm == null) {
          this.searchButtonDisabled = true;
        } else {
          this.searchLoader = true;
          this.searchButtonDisabled = false;
          this.startLevelLoader();
          apiCall({
            url: "/api/level?type=search&search=" + this.searchTerm,
            method: "GET",
          })
            .then((resp) => {
              this.filterLevels(resp);
              this.searchLoader = false;
              this.stopLevelLoader();
              this.filteredLevels = true;
            })
            .catch((error) => {
              console.log(error);
              this.searchLoader = false;
              this.stopLevelLoader();
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
            });
        }
      },
      
  
      subLevelSearch() {
        if (this.subLevelSearchTerm == null) {
          this.subLevelSearchButtonDisabled = true;
        } else {
          this.subLevelSearchLoader = true;
          this.subLevelSearchButtonDisabled = false;
          this.startLevelLoader();
          apiCall({
            url:
              "/api/sub-level?type=search&search=" +
              this.subLevelSearchTerm +
              "&level_id=" +
              this.assignedLevel.id,
            method: "GET",
          })
            .then((resp) => {
              this.subLevels = resp.data;
              this.subLevelPagination.current_page =
                resp.current_page;
              this.subLevelPagination.total = resp.total;
              this.subLevelPagination.per_page = resp.per_page;
  
              this.subLevelSearchLoader = false;
              this.filteredLevelParts = true;
            })
            .catch((error) => {
              this.subLevelSearchLoader = false;
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              console.log(error);
            });
        }
      },
      activateLevel(item) {
        confirm("Are You Sure You Want to Activate Level?") &&
          (this.activate = true);
        if (this.activate) {
          this.activateLoading = true;
          this.levelIndex = item.id;
          this.newLevel.id = item.id;
          apiCall({
            url: "/api/level?type=activate",
            data: this.newLevel,
            method: "POST",
          })
            .then((resp) => {
              this.message = "Level Account Activated Succesfully";
              this.color = "success";
              this.snackbar = true;
              this.activateLoading = false;
              this.activate = false;
              this.levelIndex = null;
              this.newLevel.id = null;
              this.fetchLevels(this.levelPagination.current_page);
            })
            .catch((error) => {
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              this.activateLoading = false;
              this.activate = false;
              this.levelIndex = null;
              this.newLevel.id = null;
              console.log(error);
            });
        }
      },
      deactivateLevel(item) {
        confirm("Are You Sure You Want to Deactivate Level?") &&
          (this.activate = true);
        if (this.activate) {
          this.deactivateLoading = true;
          this.levelIndex = item.id;
          this.newLevel.id = item.id;
          apiCall({
            url: "/api/level?type=deactivate",
            data: this.newLevel,
            method: "POST",
          })
            .then((resp) => {
              this.message = "Level Account Deactivated Succesfully";
              this.color = "success";
              this.snackbar = true;
              this.deactivateLoading = false;
              this.activate = false;
              this.levelIndex = null;
              this.newLevel.id = null;
              this.fetchLevels(this.levelPagination.current_page);
            })
            .catch((error) => {
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              this.deactivateLoading = false;
              this.activate = false;
              this.levelIndex = null;
              this.newLevel.id = null;
              console.log(error);
            });
        }
      },
     
      activateSubLevel(item) {
        confirm(
          "Are You Sure You Want to Activate Level Part?"
        ) && (this.activate = true);
        if (this.activate) {
          this.activateLoading = true;
          this.subLevelndex = item.id;
          this.newSubLevel.id = item.id;
          apiCall({
            url: "/api/sub-level?type=activate",
            data: this.newSubLevel,
            method: "POST",
          })
            .then((resp) => {
              this.message = "Level Part Activated Succesfully";
              this.color = "success";
              this.snackbar = true;
              this.activateLoading = false;
              this.activate = false;
              this.subLevelndex = null;
              this.newSubLevel.id = null;
              this.changeSubLevelPage();
            })
            .catch((error) => {
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              this.activateLoading = false;
              this.activate = false;
              this.subLevelndex = null;
              this.newSubLevel.id = null;
              console.log(error);
            });
        }
      },
  
      deactivateSubLevel(item) {
        confirm(
          "Are You Sure You Want to Deactivate Level Part?"
        ) && (this.activate = true);
        if (this.activate) {
          this.deactivateLoading = true;
          this.subLevelndex = item.id;
          this.newSubLevel.id = item.id;
          apiCall({
            url: "/api/sub-level?type=deactivate",
            data: this.newSubLevel,
            method: "POST",
          })
            .then((resp) => {
              this.message = "Level Part Deactivated Succesfully";
              this.color = "success";
              this.snackbar = true;
              this.deactivateLoading = false;
              this.activate = false;
              this.subLevelndex = null;
              this.newSubLevel.id = null;
              this.changeSubLevelPage();
            })
            .catch((error) => {
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              this.deactivateLoading = false;
              this.activate = false;
              this.subLevelndex = null;
              this.newSubLevel.id = null;
              console.log(error);
            });
        }
      },
      
      changeView(view) {
        if (view == "default") {
          this.newLevel.id = null;
          this.newLevel.name = null;
          this.newLevel.level_type_id = null;
          this.newLevel.county_id = null;
          this.newLevel.brief = null;
          this.newLevel.physical_address = null;
        } else if (view == "create") {
        //   this.getFormData();
        } else if (view == "show") {
        }
        this.view = view;
      },     
  
      changeSubLevelView(view) {
        if (view == "default") {
          this.newSubLevel.id = null;
          this.newSubLevel.level_id = null;
          this.newSubLevel.name = null;
        } else if (view == "create") {
        } else if (view == "show") {
        }
        this.subLevelView = view;
      },
      
      changePage() {
        this.startLevelLoader();
        if (this.filteredLevels == true) {
          this.searchButtonDisabled = false;
          apiCall({
            url:
              "/api/level?page=" +
              this.levelPagination.current_page +
              "&type=search&search=" +
              this.searchTerm,
            method: "GET",
          })
            .then((resp) => {
              this.filterLevels(resp);
              this.stopLevelLoader();
            })
            .catch((error) => {
              console.log(error);
              this.stopLevelLoader();
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
            });
        } else {
          this.fetchLevels(this.levelPagination.current_page);
        }
      },
      deleteLevel(item) {
        confirm("Are You Sure You Want to Delete Level") &&
          (this.delete = true);
        if (this.delete) {
          this.loading = true;
          this.levelIndex = item.id;
          apiCall({ url: "/api/level/" + item.id, method: "DELETE" })
            .then((resp) => {
              this.message = "Level Deleted Succesfully";
              this.color = "success";
              this.snackbar = true;
              this.loading = false;
              this.delete = false;
              this.levelIndex = null;
              this.fetchLevels(this.levelPagination.current_page);
            })
            .catch((error) => {
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              this.loading = false;
              this.delete = false;
              this.levelIndex = null;
              console.log(error);
            });
        }
      },
  
      deleteSubLevel(item){
        confirm("Are You Sure You Want to Remove Sub-Level?") &&
          (this.delete = true);
        if (this.delete) {
          this.loading = true;
          this.subLevelndex = item.id;
          apiCall({
            url: "/api/sub-level/" + item.id,
            method: "DELETE",
          })
            .then((resp) => {
              this.message = "Sub-Level Deleted Succesfully";
              this.color = "success";
              this.snackbar = true;
              this.loading = false;
              this.delete = false;
              this.subLevelndex = null;
              this.changeSubLevelPage();
            })
            .catch((error) => {
              this.message = "An Error Occurred";
              this.color = "error";
              this.snackbar = true;
              this.loading = false;
              this.delete = false;
              this.subLevelndex = null;
              console.log(error);
            });
        }
      },
      
    //   getFormData() {
    //     apiCall({
    //       url: "/api/level?type=formData",
    //       method: "GET",
    //     })
    //       .then((resp) => {
    //         this.formData = resp;
    //       })
    //       .catch((error) => {
    //         this.message = "anErrorOccurredCouldntGetFormDataMsg";
    //         this.color = "error";
    //       });
    //   },
      viewLog(data) {
        this.logData.message = data.id;
        this.logData.model = "App\\Models\\Level";
        this.filterLogData(this.logData);
        this.openLogDataModel();
      },
    },
    computed: {
      ...mapGetters([
        "levels",
        "levelPagination",
        "levelLoader",
        "logDataModel"
      ]),
      length: function () {
        return Math.ceil(
          this.levelPagination.total / this.levelPagination.per_page
        );
      },
      subLevelLength: function () {
        return Math.ceil(
          this.subLevelPagination.total /
            this.subLevelPagination.per_page
        );
      },
    
      dateToday() {
        var today = new Date();
  
        var timestamp =
          today.getFullYear() +
          "-" +
          this.months[today.getMonth()] +
          "-" +
          ("0" + today.getDate()).slice(-2);
        return timestamp;
      },
    },
  };
  </script>
  